import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Link as MUILink, SxProps } from "@mui/material";
import { commonStyles } from "./commonStyles";

interface LinkTextProps {
  to: string;
  text: string;
  additionalSx?: SxProps;
  onClick?: () => void;
}

const LinkText: React.FC<LinkTextProps> = ({
  to,
  text,
  additionalSx,
  onClick,
}) => {
  return (
    <MUILink
      component={RouterLink}
      to={to}
      onClick={onClick}
      sx={{
        color: commonStyles.cpaGold,
        textDecoration: "none",
        fontSize: commonStyles.fontSizes.medium,
        fontWeight: 500,
        "&:hover": {
          textDecoration: "underline",
        },
        ...additionalSx,
      }}
    >
      {text}
    </MUILink>
  );
};

export default LinkText;
